export default __webpack_public_path__ + "static/choropleth-ee50fccd6f68e04900172256c414a7a2.png";